export default ['JsonRPCService', 'JobService', function (JsonRPCService, JobService) {
    return {
        findJobByJobNumber: function findJobByJobNumber(policyChangeNumber) {
            return JsonRPCService.send('pc', 'gateway/policychange', 'findJobByJobNumber', [policyChangeNumber]);
        },
        getPolicyChangeSummary: function getPolicyChangeSummary(policyChangeNumber) {
            return JsonRPCService.send('pc', 'gateway/policychange', 'getPolicyChangeSummary', [policyChangeNumber]);
        },
        getNotesForPolicyChange: function getNotesForPolicyChange(policyChangeNumber) {
            return JsonRPCService.send('pc', 'gateway/policychange', 'getNotesForPolicyChange', [policyChangeNumber]);
        },
        createNoteForPolicyChange: function createNoteForPolicyChange(policyChangeNumber, noteDTO) {
            return JsonRPCService.send('pc', 'gateway/policychange', 'createNoteForPolicyChange', [policyChangeNumber, noteDTO]);
        },
        getDocumentsForPolicyChange: function getDocumentsForPolicyChange(policyChangeNumber) {
            return JsonRPCService.send('pc', 'gateway/policychange', 'getDocumentsForPolicyChange', [policyChangeNumber]);
        },
        getUWIssuesForPolicyChange: function getUWIssuesForPolicyChange(policyChangeNumber) {
            return JsonRPCService.send('pc', 'gateway/policychange', 'getUWIssuesForPolicyChange', [policyChangeNumber]);
        },
        referToUnderwriter: function referToUnderwriter(policyChangeNumber, noteBody) {
            return JsonRPCService.send('pc', 'gateway/policychange', 'referToUnderwriter', [policyChangeNumber, noteBody]);
        },
        withdrawPolicyChangeByPolicyChangeNumber: function withdrawPolicyChangeByPolicyChangeNumber(policyChangeNumber) {
            return JobService.withdrawJobByJobNumber(policyChangeNumber);
        }

    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/PolicyChangeService.js
// module id = 1790
// module chunks = 0